const en = {
  nav: {
    home: "Home",
    browse: "Browse Weddings",
    browseWeddings: "Browse Weddings",
    dashboard: "Dashboard",
    messages: "Messages",
    profile: "Profile",
    login: "Login",
    register: "Register",
    logout: "Logout",
    admin: "Admin",
  },
  landing: {
    hero: {
      badge: "The #1 Wedding Experience Marketplace",
      title: "Experience Unforgettable Weddings Worldwide",
      subtitle: "WEDVAYA connects couples with travelers seeking authentic cultural experiences. Become part of a special moment \u2013 as a host or as a guest.",
      cta_host: "Start as Host",
      cta_guest: "Discover Weddings",
    },
    trust: {
      freeRegistration: "Free Registration",
      securePayment: "Secure Payment",
      gdprCompliant: "GDPR Compliant",
    },
    stats: {
      weddings: "Weddings",
      worldwide: "worldwide",
      guests: "Guests",
      matched: "matched",
      countries: "Countries",
      represented: "represented",
      rating: "Rating",
      average: "average",
    },
    features: {
      title: "Why WEDVAYA?",
      subtitle: "We make it easy and safe to share unforgettable wedding experiences.",
      secure: {
        title: "Secure Payments",
        desc: "All transactions are protected by Stripe. Your money is safe until the event takes place.",
      },
      verified: {
        title: "Verified Profiles",
        desc: "Optional identity verification for additional trust between hosts and guests.",
      },
      global: {
        title: "Global Events",
        desc: "From romantic weddings in Tuscany to traditional celebrations in India.",
      },
      contact: {
        title: "Direct Contact",
        desc: "After booking, you can communicate directly with your host.",
      },
      gdpr: {
        title: "GDPR Compliant",
        desc: "Your data is secure. We strictly adhere to European data protection guidelines.",
      },
      instant: {
        title: "Instant Booking",
        desc: "Fast application process. You'll receive a response within 48 hours.",
      },
    },
    howItWorks: {
      title: "How It Works",
      subtitle: "Just a few steps to your unforgettable experience",
      step1: {
        title: "Find a Wedding",
        desc: "Browse our selection of unique weddings worldwide.",
      },
      step2: {
        title: "Send Application",
        desc: "Introduce yourself to the couple and tell them why you want to attend.",
      },
      step3: {
        title: "Confirmation & Payment",
        desc: "After approval, pay securely online. Only then is your spot reserved.",
      },
      step4: {
        title: "Celebrate",
        desc: "Experience an authentic wedding and create lifelong memories.",
      },
    },
    howItWorksHost: {
      step1: {
        title: "List Your Wedding",
        desc: "Create a profile for your wedding with all important details.",
      },
      step2: {
        title: "Review Applications",
        desc: "Check out the profiles of interested guests.",
      },
      step3: {
        title: "Get Paid",
        desc: "After the event, you automatically receive 85% of the earnings.",
      },
      step4: {
        title: "Celebrate Together",
        desc: "Share your special day with people from around the world.",
      },
    },
    tabs: {
      forGuests: "For Guests",
      forHosts: "For Hosts",
    },
    testimonials: {
      title: "What Our Community Says",
      subtitle: "Real experiences from real people",
    },
    featured: {
      title: "Featured Weddings",
      subtitle: "Discover unique celebrations around the world",
      viewAll: "View All",
      perPerson: "per person",
    },
    cta: {
      title: "Ready for Your Unforgettable Experience?",
      subtitle: "Join the WEDVAYA community",
      description: "Whether you want to share your wedding with the world or seek a unique travel experience \u2013 WEDVAYA makes it possible.",
      button: "Register for Free",
      becomeHost: "Become a Host Now",
      learnMore: "Learn More",
    },
    press: {
      title: "As seen in",
    },
  },
  auth: {
    login: {
      title: "Welcome Back",
      email: "Email",
      password: "Password",
      button: "Login",
      noAccount: "Don't have an account?",
      register: "Register now",
      forgotPassword: "Forgot password?",
    },
    register: {
      title: "Create Account",
      name: "Full Name",
      email: "Email",
      password: "Password",
      role: "I want to...",
      roleHost: "Host a wedding",
      roleGuest: "Attend weddings",
      terms: "I accept the Terms and Privacy Policy",
      button: "Register",
      hasAccount: "Already registered?",
      login: "Login now",
    },
    forgotPassword: {
      title: "Forgot Password?",
      description: "Enter your email and we'll send you a reset link",
      submit: "Send Reset Link",
      sent: "Check Your Email",
      sentDescription: "If an account exists with this email, you will receive a password reset link.",
      backToLogin: "Back to Login",
    },
    resetPassword: {
      title: "Reset Password",
      description: "Enter your new password below",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      submit: "Reset Password",
      success: "Password Reset!",
      successDesc: "Your password has been successfully reset. You can now login with your new password.",
      goToLogin: "Go to Login",
      mismatch: "Passwords do not match",
      tooShort: "Password must be at least 6 characters",
    },
    verification: {
      verifying: "Verifying your email...",
      pleaseWait: "Please wait a moment",
      successTitle: "Email Verified!",
      success: "Your email has been verified successfully!",
      errorTitle: "Verification Failed",
      noToken: "No verification token provided",
      goToLogin: "Go to Login",
      tryAgain: "Register Again",
    },
  },
  dashboard: {
    host: {
      title: "Host Dashboard",
      myWeddings: "My Weddings",
      applications: "Applications",
      earnings: "Earnings",
      messages: "Messages",
      createWedding: "Create Wedding",
      noWeddings: "No weddings created yet",
    },
    guest: {
      title: "Guest Dashboard",
      myApplications: "My Applications",
      browseWeddings: "Browse Weddings",
      messages: "Messages",
      profile: "My Profile",
    },
  },
  wedding: {
    search: {
      title: "Find Weddings",
      location: "Location",
      date: "Date",
      price: "Price",
      search: "Search",
      reset: "Reset",
      noResults: "No weddings found",
    },
    card: {
      slots: "slots available",
      perGuest: "per guest",
      apply: "Apply",
      viewDetails: "View Details",
    },
    detail: {
      about: "About this Wedding",
      host: "Host",
      location: "Location",
      date: "Date",
      dresscode: "Dress Code",
      price: "Price per Guest",
      slots: "Available Slots",
      apply: "Apply Now",
      alreadyApplied: "Already Applied",
    },
    create: {
      title: "Create New Wedding",
      titleField: "Title",
      description: "Description",
      location: "Location",
      country: "Country",
      date: "Date",
      dresscode: "Dress Code",
      price: "Price per Guest",
      slots: "Number of Guests",
      currency: "Currency",
      submit: "Create Wedding",
    },
    verification: {
      badge: "Verification",
      pending: "Awaiting Verification",
      pendingDesc: "Your wedding is under review by our team. It is not yet publicly visible.",
      verified: "Verified",
      verifiedDesc: "Your identity has been confirmed. Your wedding is now publicly visible.",
      rejected: "Verification Rejected",
      rejectedDesc: "Your verification was rejected. Please re-upload:",
      rejectedReason: "Reason: {reason}",
      uploadTitle: "Upload Identity Proof",
      uploadDesc: "To prevent fraud, the couple's identity must be confirmed before going public. Upload documents that verify your name and marriage.",
      docType: "Document Type",
      docTypeSelect: "Select document",
      docTypeIdFront: "ID Front",
      docTypeIdBack: "ID Back",
      docTypeMarriageCert: "Marriage Certificate",
      docTypeMarriageReg: "Marriage Registration",
      uploadButton: "Upload Document",
      uploading: "Uploading...",
      uploadSuccess: "Document uploaded",
      uploadError: "Upload failed",
      requirement: "At least one ID (front) and one marriage proof is required.",
      reUpload: "Re-upload",
      uploaded: "Uploaded",
      incomplete: "Incomplete",
      completeHint: "Upload at least one ID (front) and one marriage proof to complete verification",
      submit: "Submit Verification",
    },
  },
  application: {
    status: {
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
    },
    payment: {
      pending: "Payment Pending",
      paid: "Paid",
      pay: "Pay Now",
    },
    approve: "Approve",
    reject: "Reject",
  },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },
  messages: {
    title: "Messages",
    noMessages: "No messages",
    placeholder: "Write a message...",
    send: "Send",
  },
  admin: {
    title: "Admin Dashboard",
    stats: {
      users: "Users",
      hosts: "Hosts",
      guests: "Guests",
      weddings: "Weddings",
      activeWeddings: "Active Weddings",
      applications: "Applications",
      revenue: "Total Revenue",
      platformEarnings: "Platform Earnings",
    },
    tabs: {
      overview: "Overview",
      users: "Users",
      weddings: "Weddings",
      transactions: "Transactions",
      verification: "Verification",
    },
    actions: {
      ban: "Ban",
      unban: "Unban",
      feature: "Feature",
      unfeature: "Unfeature",
    },
  },
  common: {
    loading: "Loading...",
    error: "An error occurred",
    success: "Success",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    back: "Back",
    next: "Next",
    language: "Language",
    currency: "Currency",
  },
  footer: {
    about: "About",
    privacy: "Privacy",
    terms: "Terms",
    contact: "Contact",
    description: "The global marketplace for unforgettable wedding experiences.",
    copyright: "\u00a9 2024 WEDVAYA. All rights reserved.",
  },
  notifications: {
    title: "Notifications",
    empty: "No notifications yet",
    markAllRead: "Mark all read",
  },
  chat: {
    conversations: "Conversations",
    search: "Search conversations...",
    noConversations: "No conversations yet",
    selectConversation: "Select a conversation",
    selectConversationDesc: "Choose a conversation from the list to start chatting",
    online: "Online",
    offline: "Offline",
    connecting: "Connecting...",
    noMessages: "No messages yet",
    startConversation: "Start the conversation!",
    placeholder: "Type a message...",
    you: "You",
  },
  cookies: {
    title: "We use cookies",
    description: "We use cookies to improve your experience, analyze traffic, and for marketing purposes.",
    acceptAll: "Accept All",
    rejectAll: "Reject All",
    customize: "Customize",
    settingsTitle: "Cookie Settings",
    functional: "Functional Cookies",
    functionalDesc: "Essential for the website to function properly.",
    analytics: "Analytics Cookies",
    analyticsDesc: "Help us understand how visitors interact with the website.",
    marketing: "Marketing Cookies",
    marketingDesc: "Used to deliver personalized advertisements.",
    saveSettings: "Save Settings",
  },
};

export default en;
